
export const detectIfSelectShow =  () => {

   let year = document.querySelector('.filters__select-holder--year');
   let month = document.querySelector('.filters__select-holder--month');
   let category = document.querySelector('.filters__select-holder--category');
   let form = document.querySelector('.filters__form');
   
   var removePageParameter = () => {
      let currentUrl = window.location.href;
      let templatePageRegex = /\/page\/\d+\//;
      let updatedUrl = currentUrl.replace(templatePageRegex, '/');
      form.action = updatedUrl;
   }
   var checkIfAllSelected = (select) => {
      let parent = select.parentNode;
      parent.querySelector("img").style.display= "none";
      parent.querySelector(".filters__border").style.display="none";
      parent.querySelector(".filters__clear").style.display="block";
   }
   var clearFilter = (filter) => {
      let parentElement = filter.parentElement;
      let selectElement = parentElement.querySelector('select'); 
      selectElement.selectedIndex = 1; 
      removePageParameter();
    }

   if(document.body.classList.contains("blog")|| document.body.classList.contains("page-template-template-kalendarz-wydarzen")) {
     if(!form.querySelector(".filters__select-holder--hidden")){
         if(category){
            category.addEventListener("change",()=>{
               removePageParameter();
               form.submit();
           })
         }
       
        year.addEventListener("change",()=>{
         removePageParameter();
           form.submit();
        })
     }
     if(category){
      category.querySelector('select').addEventListener("change",()=>{
         checkIfAllSelected(category.querySelector('select'));
          year.classList.remove("filters__select-holder--hidden");
        });
     }
     

     let categoryFilter = document.querySelector(".filters__clear--category");
     let yearFilter = document.querySelector(".filters__clear--year");
     let monthFilter = document.querySelector(".filters__clear--month");
     let clearAllBtn = document.querySelector(".filters__clear-all");

     clearAllBtn.addEventListener("click",()=>{
      clearFilter(monthFilter);
      clearFilter(yearFilter);
      if(categoryFilter){
         clearFilter(categoryFilter);
      }
      form.submit();
     })
     monthFilter.addEventListener("click",()=>{
        clearFilter(monthFilter);
        form.submit();
     });
     yearFilter.addEventListener("click",()=>{
        clearFilter(yearFilter);
        form.submit();
     });
     if(categoryFilter){
      categoryFilter.addEventListener("click",()=>{
         clearFilter(categoryFilter);
         form.submit();
      });
 
      }
    
     
   }
   
     
   if(year ){
       year.querySelector('select').addEventListener('change', function() {
         checkIfAllSelected(year.querySelector('select'));
          month.classList.remove("filters__select-holder--hidden");
       }); 
       month.querySelector('select').addEventListener('change', function() {
         removePageParameter();
          form.submit();
       });
   }

   
  
}
